// Брокеры, для которых согласие с офертой/реверс-солиситацией проставляется
// автоматически: не показываем чекбокс согласия при входе/регистрации и не
// показываем попапы подписания документов. Должно совпадать с бэкендом
// (users/constants.py: AGREEMENT_AUTO_ACKNOWLEDGE_BROKER_IDS).
const AGREEMENT_AUTO_ACKNOWLEDGE_BROKER_IDS = [10, 229];

const isAgreementAutoAcknowledgedBroker = brokerId => AGREEMENT_AUTO_ACKNOWLEDGE_BROKER_IDS.includes(Number(brokerId));

export { AGREEMENT_AUTO_ACKNOWLEDGE_BROKER_IDS, isAgreementAutoAcknowledgedBroker };
